import { ActionType, SidebarAction } from "./action";
import { ISidebarState } from "./state";

export const SidebarReducer = (state: ISidebarState, action: SidebarAction) => {
  switch (action.type) {
    case ActionType.ShowSidebar:
      return { ...state, showSidebar: !state.showSidebar };
  }
};
